import { Box, LinearProgress, Typography } from '@mui/material'
import { PlannedExpertiseProgressBarProps } from './_props'

export default function PlannedExpertiseProgressBar({
    activeStep,
    steps,
    workflowLabel,
}: PlannedExpertiseProgressBarProps) {
    const safeWorkflowLabel = workflowLabel || '—'
    const safeSteps = Math.max(steps, 1)
    const rawPercent = Math.round((activeStep / safeSteps) * 100)
    const percent = Math.min(Math.max(rawPercent, 0), 100)

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '80%' }}>
            <Typography
                sx={{
                    display: 'flex',
                    minHeight: '32px',
                    padding: '0 16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '24px',
                    background: '#E7E8FF',
                    color: '#575BAF',
                    fontSize: '16px',
                    marginRight: '40px',
                }}
            >
                {safeWorkflowLabel}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, gap: '8px' }}>
                <LinearProgress
                    variant="determinate"
                    value={percent}
                    sx={{
                        flex: 1,
                        height: 6,
                        borderRadius: 800,
                        backgroundColor: '#D8DBF2',
                        '& .MuiLinearProgress-bar': {
                            borderRadius: 100,
                            backgroundColor: '#6E72D8',
                        },
                    }}
                />
                <Typography
                    sx={{
                        minWidth: 40,
                        fontWeight: 600,
                        fontSize: '14px',
                        color: '#575BAF',
                    }}
                >
                    {percent}%
                </Typography>
            </Box>
        </Box>
    )
}
